export const ACTION_RESOURCE_TYPES = {
  NO_RESOURCE: 'No Resource',
  INVESTMENT: 'Investment',
  NUMBER_OFF_STAFF_DAYS: 'Number of staff days',
};

export const ACTION_RESOURCE_FREQUENCY_VALUES = {
  ONE_TIME: 'One Time',
  RECURRING: 'Recurring',
};

export const ACTION_RESOURCE_STAFF_TYPE_VALUES = {
  JUNIOR: 'Junior',
  MIDLEVEL: 'Mid-level',
  SENIOR: 'Senior',
  EXTERNAL: 'External',
};

export const ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES = {
  DAYS: 'Days',
  HOURS: 'Hours',
  MINUTES: 'Minutes',
};

export const ACTION_RESOURCE_BASIS_VALUES = {
  PER_DAY: 'Day',
  PER_WEEK: 'Week',
  PER_MONTH: 'Month',
  PER_YEAR: 'Year',
};

export const ACTION_RESOURCE_BASIS_REQUEST_PAYLOAD_MAP = {
  [ACTION_RESOURCE_BASIS_VALUES.PER_DAY]: 'day',
  [ACTION_RESOURCE_BASIS_VALUES.PER_WEEK]: 'week',
  [ACTION_RESOURCE_BASIS_VALUES.PER_MONTH]: 'month',
  [ACTION_RESOURCE_BASIS_VALUES.PER_YEAR]: 'year',
};

export const ACTION_RESOURCE_BASIS_RESPONSE_PAYLOAD_MAP = {
  'day': ACTION_RESOURCE_BASIS_VALUES.PER_DAY,
  'week': ACTION_RESOURCE_BASIS_VALUES.PER_WEEK,
  'month': ACTION_RESOURCE_BASIS_VALUES.PER_MONTH,
  'year': ACTION_RESOURCE_BASIS_VALUES.PER_YEAR,
};

export const ACTION_RESOURCE_STAFF_TYPE_REQUEST_PAYLOAD_MAP = {
  [ACTION_RESOURCE_STAFF_TYPE_VALUES.JUNIOR]: 'junior',
  [ACTION_RESOURCE_STAFF_TYPE_VALUES.MIDLEVEL]: 'midlevel',
  [ACTION_RESOURCE_STAFF_TYPE_VALUES.SENIOR]: 'senior',
  [ACTION_RESOURCE_STAFF_TYPE_VALUES.EXTERNAL]: 'external',
};

export const ACTION_RESOURCE_STAFF_TYPE_RESPONSE_PAYLOAD_MAP = {
  'junior': ACTION_RESOURCE_STAFF_TYPE_VALUES.JUNIOR,
  'midlevel': ACTION_RESOURCE_STAFF_TYPE_VALUES.MIDLEVEL,
  'senior': ACTION_RESOURCE_STAFF_TYPE_VALUES.SENIOR,
  'external': ACTION_RESOURCE_STAFF_TYPE_VALUES.EXTERNAL,
};

export const ACTION_RESOURCE_STAFF_DAY_TYPE_REQUEST_PAYLOAD_MAP = {
  [ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES.DAYS]: 'days',
  [ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES.HOURS]: 'hours',
  [ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES.MINUTES]: 'minutes',
};

export const ACTION_RESOURCE_STAFF_DAY_TYPE_RESPONSE_PAYLOAD_MAP = {
  'days': ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES.DAYS,
  'hours': ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES.HOURS,
  'minutes': ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES.MINUTES,
};

export const ACTION_RESOURCE_FREQUENCY_RESPONSE_VALUES_MAP = {
  'one_time': ACTION_RESOURCE_FREQUENCY_VALUES.ONE_TIME,
  'recurring': ACTION_RESOURCE_FREQUENCY_VALUES.RECURRING,
};

export const ACTION_RESOURCE_TYPES_RESPONSE_PAYLOAD_MAP = {
  'No Resource': ACTION_RESOURCE_TYPES.NO_RESOURCE,
  'investment': ACTION_RESOURCE_TYPES.INVESTMENT,
  'number_of_staff_days': ACTION_RESOURCE_TYPES.NUMBER_OFF_STAFF_DAYS
};
